import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AccessoryDelete } from '../../models/quotation-model/catalogs/accessory-delete.model';
import { AccessoryQuotationUpdate } from '../../models/quotation-model/main/accessory-quotation-update.model';
import { AccessoryQuotation } from '../../models/quotation-model/main/accessory-quotation.model';
import { EditByModel } from '../../models/quotation-model/main/edit-by-model-quotation.model';
import { GetQuotationPDF } from '../../models/quotation-model/main/get-Quotation-Pdf.model';
import { InsertQuotation } from '../../models/quotation-model/main/insert-quotation.model';
import { OtherModelQuotation } from '../../models/quotation-model/main/other-model';
import { QuotationComparative } from '../../models/quotation-model/main/quotation-comparative.model';
import { QuotationCompareCoverages } from '../../models/quotation-model/main/quotation-compare-coverages.model';
import { QuotationCompareDeadLines } from '../../models/quotation-model/main/quotation-compare-deadlines.model';
import { QuotationEditFinalValues } from '../../models/quotation-model/main/quotation-edit-final-values.model';
import { QuotationEditModel } from '../../models/quotation-model/main/quotation-edit-model';
import { QuotationFinancialValues } from '../../models/quotation-model/main/quotation-financial-values.model';
import { QuotationFormalityDelete } from '../../models/quotation-model/main/quotation-formality-delete.model';
import { QuotationFormalityUpdate } from '../../models/quotation-model/main/quotation-formality-update.model';
import { QuotationFormality } from '../../models/quotation-model/main/quotation-formality.model';
import { QuoatationPlan } from '../../models/quotation-model/main/quotation-plan.model';
import { QuotationRatification } from '../../models/quotation-model/main/quotation-ratification.model';
import { SendMailTicketObj } from '../../models/quotation-model/main/send-mail.model';
import { SendTicketObj } from '../../models/quotation-model/main/send-ticket.model.model';
import { UpdateTicketObj } from '../../models/quotation-model/main/update-ticket.model';
import { EditClient } from '../../models/quotation-model/main/user-update.model';
import { GeneralService } from '../general.service';
import { LeaseLine, LeaseLinePaged } from '../../models/lease-line-model/lease-line.model';
import { PagedFilter } from '../../models/components-general/general-filter.model';
export interface GenericResponse {
  result: string;
  message: string;
  data: string;
}
@Injectable({
  providedIn: 'root',
})
export class QuotationService {
  token: string | null;
  appToken: string | null;
  public URL_API2 = environment.apiURLNew;
  public URL_API = environment.apiURL;
  // emisor para comunicarse con app-premises-section
  public emitFinancialValues = new EventEmitter();

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {
    this.token = localStorage.getItem('token');
    this.appToken = localStorage.getItem('appToken');
  }

  public createQuotation(insertQuotation: InsertQuotation) {
    return this.http.post<InsertQuotation>(this.URL_API + '/Quotation/Insert', insertQuotation);
  }

  createQuotationOtherModel(otherModelQuotation: OtherModelQuotation) {
    return this.http.put<EditByModel>(this.URL_API + '/Quotation/OtherModel', otherModelQuotation);
  }

  public updateQuotation(editQuoatationByModel: EditByModel) {
    return this.http.put<EditByModel>(
      this.URL_API + '/Quotation/ChangeModel',
      editQuoatationByModel,
    );
  }

  public compareQuotation(
    quotationId: number,
    deadLines: QuotationCompareDeadLines[],
    coverages: QuotationCompareCoverages[],
  ): Observable<QuotationComparative[]> {
    var semiUrl = this.createFinalUrl(
      quotationId,
      this.createDeadLinesUrl(deadLines),
      this.createCoveragesUrl(coverages),
    );
    return this.http.get<QuotationComparative[]>(this.URL_API + '/Quotation/Compare?' + semiUrl);
  }

  public changeFinalValuesQuotation(quotationEditFinalValues: QuotationEditFinalValues) {
    return this.http.patch(this.URL_API + '/Quotation/ChangeFinalValues', quotationEditFinalValues);
  }

  public changeFinancialConditionQuotation(
    quotationEdit: QuotationEditModel,
  ): Observable<any | null> {
    if (quotationEdit) {
      return this.http.patch(this.URL_API + '/Quotation/ChangeFinancialCondition', quotationEdit);
    } else {
      return of(null);
    }
  }

  public changePlanTypeQuotation(quotationPlanModel: QuoatationPlan) {
    return this.http.patch<QuoatationPlan>(
      this.URL_API + '/Quotation/ChangePlanType',
      quotationPlanModel,
    );
  }

  public changeRatificationQuotation(quotattionRatificationModel: QuotationRatification) {
    return this.http.patch<QuotationRatification>(
      this.URL_API + '/Quotation/ChangeRatification',
      quotattionRatificationModel,
    );
  }

  public getQuotationFinancialValues(idQuotation: number): Observable<QuotationFinancialValues> {
    return this.http.get<QuotationFinancialValues>(
      this.URL_API + '/Quotation/GetValues?quotationId=' + idQuotation,
    );
  }

  public createDeadLinesUrl(ids: QuotationCompareDeadLines[]): string {
    var queryString = '';
    ids.forEach((id: any) => {
      queryString = queryString + Object.keys(id).map((key: any) => key + '=' + id[key]) + '&';
    });
    const editQueryString = queryString.slice(0, -1);
    return editQueryString;
  }

  // metodo que devuelve en STRING la url
  // recibe un arreglo de objetos, del cual solo me interesa el id o llave
  public createCoveragesUrl(ids: QuotationCompareCoverages[]): string {
    // inicializamos el querystring
    var queryString = '';
    // Recorro la lista concatenando solo la llave que necesito
    ids.forEach((id: any) => {
      queryString = queryString + Object.keys(id).map((key) => key + '=' + id[key]) + '&';
    });
    // elimino el ultimo ampersand
    const editQueryString = queryString.slice(0, -1);
    // Listo!
    return editQueryString;
  }

  public createFinalUrl(quotationId: number, deadLinesIds: string, coveragesIds: string) {
    return 'quotationId=' + quotationId + '&' + deadLinesIds + '&' + coveragesIds;
  }

  public sendTicket(sendTicketObj: SendTicketObj): Observable<number> {
    return this.http.post<number>(this.URL_API + '/Ticket/InsertUpdateByQuotation', {
      quotationId: sendTicketObj.quotationId,
    });
  }

  public updateTicket(updateTicketObj: UpdateTicketObj): Observable<number> {
    return this.http.post<number>(this.URL_API + '/Ticket/InsertUpdateByQuotation', {
      ticketId: updateTicketObj.ticketId,
      quotationId: updateTicketObj.quotationId,
    });
  }

  public sendMailDynamic(sendTicketObj: SendMailTicketObj): Observable<number> {
    return this.http.post<number>(this.URL_API + '/Ticket/SendEmail', sendTicketObj);
  }

  public getAccessorys(quotationId: number): Observable<AccessoryQuotation[]> {
    return this.http.get<AccessoryQuotation[]>(
      this.URL_API + '/Quotation/GetAccessories?quotationId=' + quotationId,
    );
  }

  public updateAccessory(accessoryQuotationUpdate: AccessoryQuotationUpdate) {
    return this.http.patch<AccessoryQuotationUpdate>(
      this.URL_API + '/Quotation/ChangeAccessory',
      accessoryQuotationUpdate,
    );
  }

  public deleteAccessory(accessoryQuotationDelete: AccessoryDelete) {
    return this.http.patch<AccessoryDelete>(
      this.URL_API + '/Quotation/RemoveAccessory',
      accessoryQuotationDelete,
    );
  }

  public getQuotationFormalitys(quotationId: number) {
    return this.http.get<QuotationFormality[]>(
      this.URL_API + '/Quotation/GetFormalities?quotationId=' + quotationId,
    );
  }

  public updateFormality(quotationFormalityUpdate: QuotationFormalityUpdate) {
    return this.http.patch<QuotationFormalityUpdate>(
      this.URL_API + '/Quotation/ChangeFormality',
      quotationFormalityUpdate,
    );
  }

  public deleteFormality(quotationFormalityDelete: QuotationFormalityDelete) {
    return this.http.patch<QuotationFormalityDelete>(
      this.URL_API + '/Quotation/RemoveFormality',
      quotationFormalityDelete,
    );
  }

  public getQuotationPDF(getQuotationPFModel: GetQuotationPDF) {
    return this.http.post<GenericResponse>(
      this.URL_API + '/Quotation/GetQuotationPdf',
      getQuotationPFModel,
    );
  }

  public updateUser(editClient: EditClient) {
    return this.http.patch<EditClient>(this.URL_API + '/Quotation/ChangeClient', editClient);
  }

  public sendQuoteEmail(body: {
    dealer: number;
    email: string;
    idQuotation: number;
    isMasivo: boolean;
    personType: number;
    subject: string;
  }) {
    const params = this.generalService.buildParams({
      dealer: body.dealer,
      email: body.email,
      idQuotation: body.idQuotation,
      isMasivo: body.isMasivo,
      personType: body.personType,
      subject: encodeURIComponent(body.subject),
    });

    return this.http.post<GenericResponse>(`${this.URL_API2}/sendQuoteEmail`, {}, { params });
  }

  public annualInsurance(
    quotationId: number,
    body: { isAnnualInsurance: boolean },
  ): Observable<any> {
    return this.http.patch<any>(
      `${this.URL_API2}/quotations/${quotationId}/annual-insurance`,
      body,
    );
  }

  public insertLeaseLine(leaseLineInsert: LeaseLine): Observable<LeaseLine | null> {
    return this.http
      .post<LeaseLine>(
        this.URL_API + '/Quotation/InsertLeaseLine',
        leaseLineInsert,
      )
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getLeaseLine(pageFilter: PagedFilter): Observable<LeaseLinePaged | null> {
    const params = this.generalService.buildParams(pageFilter);
    return this.http
      .get<LeaseLinePaged>(this.URL_API + '/Quotation/GetLeaseLinesPaged', { params })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
  public getDetailedLeaseLine(leaseLineId: number): Observable<LeaseLine[] | null> {
    return this.http
      .get<LeaseLine[]>(this.URL_API + '/Quotation/GetDetailedLeaseLine?leaseLineId=' + leaseLineId)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
